// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".modal-custom-partner .modal-content {\n  height: 100vh;\n}", ""]);
// Exports
module.exports = exports;
